<template>
  <div class="h-100">
    <router-link
      :to="{ name: 'categories.show', params: { username: category.user.username, slug: category.slug } }"
      class="d-flex flex-column h-100"
    >
      <div class="common-card group-entity-card d-flex flex-column h-100">
        <div class="cover" :style="coverImage">
          <div class="ellipsis-block">
            <span
              class="mx-1 py-1 background-white rounded-xl shadow-light font-size-xSmall"
              >
              <b-dropdown
                  toggle-class="p-0 bordered-0 d-flex dropdown-toggle "
                  variant="none"
                  menu-class="font-size-xSmall p-3 text-center dropdown-default"
                  no-caret
                  dropleft
              >
                  <template v-slot:button-content>
                  <i class="fa fa-ellipsis-v px-3 text-color2" aria-hidden="true"></i>
                  </template>
                  <b-dropdown-item
                  link-class="p-0"
                  :to="editUrl"
                  v-if="category && user && category.user.id === user.id"
                  >
                  Editar
                  <hr class="h-1 background-color2" />
                  </b-dropdown-item>
                  <b-dropdown-item
                  link-class="p-0"
                  v-if="category && user && category.user.id === user.id"
                  v-b-modal="destroyModalId"
                  >
                  Excluir
                  </b-dropdown-item>
                  <hr class="h-1 background-color2" v-if="category && user && category.user.id === user.id"/>
                  <b-dropdown-item
                  link-class="p-0"
                  v-b-modal="shareModalId"
                  >
                  Compartilhar
                  </b-dropdown-item>
              </b-dropdown>
            </span>
          </div>
        </div>
        <div class="content d-flex flex-column">
          <h2 :title="category.name" class="font-size-medium font-weight-bold wrap-ellipsis">{{ category.name }}</h2>
          <p class="wrap-ellipsis font-size-small" :title="category.description">{{ category.description }}</p>
          <div class="mt-4 actions d-flex flex-md-column flex-lg-row align-items-center justify-content-between">
            <span class="text-color2 d-flex align-items-center justify-content-start font-size-xSmall">
              <template
                v-if="category.entity_count >= 0"
              >
                {{ `${category.entity_count} ${category.entity_count > 1 ? 'publicações' : 'publicação'}` }}
              </template>
              <template v-else>
                Categoria vazia
              </template>
            </span>
            <Button
              class="btn-outline-color2 mt-md-3 mt-lg-0"
            >
              Acessar
            </Button>
          </div>
        </div>
      </div>
    </router-link>
    <ShareModal
      type="category"
      :target="category"
      :modalId="shareModalId"
    />
    <DestroyCategoryModal
      :category="category"
      @category-destroyed="$emit('category-destroyed', category.id)"
      :modalId="destroyModalId"
    />
  </div>
</template>

<script>

import variables from '@/mixins/variables'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button.vue'

import DestroyCategoryModal from '@/components/categories/DestroyCategoryModal.vue'
import ShareModal from '@/components/share/ShareModal.vue'

export default {
  name: 'CategoryCard',
  components: {
    Button,
    DestroyCategoryModal,
    ShareModal
  },
  props: ['category'],
  mixins: [variables],
  computed: {
    coverImage () {
      return {
        backgroundImage: this.category ? `url('${this.category.cover}')` : `url('${this.noCoverUrl}')`
      }
    },
    ...mapState('users', {
      user: state => state.user
    }),
    destroyModalId () {
      return 'destroy-category-' + this.category.id
    },
    shareModalId () {
      return 'modal-share-' + this.category.id
    },
    editUrl () {
      const route = {}
      if (this.category) {
        route.name = 'categories.edit'
        route.params = { username: this.category.user.username, slug: this.category.slug }
        const props = this.$router.resolve(route)
        return props.href
      }
      return '/'
    }
  }
}
</script>

<style lang="scss" scoped>

.ellipsis-block{
  position: absolute;
  right: 10px;
  justify-content: space-between;
  display: flex;
  align-items: center;
  z-index: 9;
  top: 10px;
}

.content {
  flex-grow: 1;

  h2 {
    max-height: 60px;
    overflow: hidden;
  }

  .actions {
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
}
</style>
